import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const MapMobileSwitchView = ({ onClickButton, isListActive = false }) => {
  return <Button size={'large'} type="secondary" icon={isListActive ? <CroplerIcon name="map" /> : <CroplerIcon name="list"/>} onClick={onClickButton} />
}

export default MapMobileSwitchView